import { ReactElement, useState } from "react";
import { useLocation } from "react-router-dom";
import { T } from "react-translator-component";
import { Avatar, Box, Typography } from "@mui/material";
import dayjs from "../util/dayjs";
import { colors } from "../common/colors";
import style from "../pages/GreenCity/payments/styles";
import { convertUserImage } from "../util/utils";
import appServices from "../services/app-services/appServices";
import ImageViewer from "./GreenCity/ImageViewer";

interface Props{
  reimbursement?: any
}

export default function ReimbursementTable ({ reimbursement }: Props): ReactElement {
  const [images, setImages] = useState<any>([])
  const [showImageView, setShowImageView] = useState<boolean>(false)
  // ユーザーの立て替え申請履歴画面(/reimbursements)かどうかの判定で使用
  const currentScreen = useLocation().pathname

  const handleImage = () => {
    if (!reimbursement?.id) return

    setShowImageView(true)

    if (images.length > 0) return

    appServices.getReimbursementImage(reimbursement.id).then((res) => {
      setImages([ res ])
    }).catch((e: any) => {
      // pass
    })
  };

  const displayDate = (date: string) => {
    if (!date) return ""

    return dayjs(date).format("YYYY年M月D日(ddd)")
  }

  const renderCell = (title: string, data: any, subject?: 'demandAddress' | 'image') => {
    return (
      <tr>
        <th
          style={{
            backgroundColor: colors.farm_gray50,
            border: `1px solid ${colors.farm_gray15}`,
            width: "33%",
            fontSize: 12,
          }}
        >
          {title}
        </th>
        <td
          onClick={() => subject === 'image' && handleImage() }
          style={
            subject === 'demandAddress' ? {
              border: `1px solid ${colors.farm_gray15}`,
              width: "67%",
              overflow: "hidden", // Prevent content overflow
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: 12,
            } : {
              border: `1px solid ${colors.farm_gray15}`,
              width: "67%",
              fontSize: 12, // Keep font size
              whiteSpace: "normal", // Allow text to wrap to the next line
              wordBreak: "break-word", // Break long words if needed
              color: subject === 'image' ? "#3939a6" : "black",
            }
          }
        >
          {data}
        </td>
      </tr>
    )
  }

  return (
    <>
      <div style={{ marginBottom: 10, marginTop: 10, display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
        <table style={{ width: "98%", tableLayout: "fixed", marginBottom: 4, marginTop: 4 }}>
          <tbody>
            {renderCell(
              currentScreen === '/reimbursements' ? T("reimbursement_demand_address") : T("reimbursement_applier"),
              (
                <Box sx={style.rowMargin}>
                  {currentScreen !== '/reimbursements' && (
                    <Avatar src={convertUserImage(reimbursement?.user?.image)} sx={{ ...style.avatar, width: "30px" }} />
                  )}

                  {currentScreen === '/reimbursements' ?
                    <Typography>{reimbursement?.member_group?.name}</Typography> :
                    <Typography>{reimbursement?.user?.nickname}</Typography>
                  }
                </Box>
              ),
              'demandAddress'
            )}

            {renderCell(
              T("reimbursement_payment_date"),
              displayDate(reimbursement?.payment_date)
            )}

            {renderCell(
              T("payment_address"),
              reimbursement?.payment_address
            )}

            {renderCell(
              T("required_amount"),
              `￥${reimbursement?.amount?.toLocaleString()}`
            )}

            {renderCell(
              T("reimbursement_payment_method"),
              reimbursement?.image_name,
              'image'
            )}

            {renderCell(
              T("payment_details"),
              reimbursement?.details
            )}

            {renderCell(
              T("reimbursement_created_at"),
              displayDate(reimbursement?.created_at)
            )}

            {renderCell(
              T("reimbursement_id"),
              reimbursement?.id
            )}

            {currentScreen !== "/rejectreimbursement" && (
              renderCell(
                T("reimbursement_updated_at"),
                reimbursement?.status === "Approved" ? displayDate(reimbursement?.updated_at) : ""
              )
            )}

            {(currentScreen === "/reimbursements" && reimbursement?.status === "Rejected") && (
              renderCell(
                T("reimbursement_reason"),
                reimbursement?.rejection_reason
              )
            )}

            {renderCell(
              T("reimbursement_status"),
              T(`reimbursement_${reimbursement?.status?.toLowerCase()}`)
            )}
          </tbody>
        </table>
      </div>

      <ImageViewer
        images={images}
        isModalOpen={showImageView&& images.length > 0}
        onClose={() => setShowImageView(false)}
      />
    </>
  )
}
